export const SEARCH_EMAIL_LOADING = "app/SEARCH_EMAIL_LOADING";
export const SEARCH_EMAIL_RESULTS = "app/SEARCH_EMAIL_RESULTS";
export const CHANGE_PAGE = "app/CONTRACTORS_CHANGE_PAGE";
export const CHANGE_PER_PAGE = "app/CONTRACTORS_CHANGE_PER_PAGE";
export const CHANGE_TASK_USER = "app/CHANGE_TASK_USER";